<template>
	<div class="modal fade" id="modal-cadastro-ramal">
		<div class="modal-dialog modal-xl">
			<div class="modal-content">
				<div class="modal-header">
					<h4 class="modal-title">Ramal</h4>
					<button type="button" class="close" data-dismiss="modal">&times;</button>
				</div>

				<div class="modal-body">
					<div class="row">
						<div class="col-md-12">
							<img :src="logotipo" style="width: 16%; margin-left: 42%;">
						</div>
					</div>

					<div class="row" v-if="action == 'view'">
						<div class="col-sm-2 col-lg-1">
							<strong>ID: </strong> {{ ramal.ID }}
						</div>
					</div>

					<hr>

					<div class="row">
				        <div class="col-lg-4">
				            <div class="form-group">
				                <label>Nome</label>
				                <input type="text" class="form-control form-control-sm" :class="[(ramal.NAME) ? '' : incomplete]" v-model="ramal.NAME">
				            </div>
				        </div>

						<div class="col-lg-4">
				             <div class="form-group">
				                <label>Ramal</label>
				                <input type="text" class="form-control form-control-sm" :class="[(ramal.EXTENSION) ? '' : incomplete]" v-model.number="ramal.EXTENSION">
				            </div>
				        </div>

				        <div class="col-lg-4">
				        	<div class="form-group">
				                <label>{{view_nome.setor_nome}}</label>
				                <select class="form-control form-control-sm" v-if="setores.result" :class="[(ramal.PARENT_ID) ? '' : incomplete]" v-model="ramal.PARENT_ID" @change="autocomplete_phone">
				                	<option v-for="setor in setores.result" :value="setor.ID" :key="setor.ID">{{ setor.NAME }}</option>
				                </select>
				            </div>
				        </div>
				    </div>

				</div>

				<div class="modal-footer">
					<button class="btn btn-danger btn-sm"  v-if="action == 'view'" @click="deletar"  >Deletar</button>
					<button class="btn btn-warning btn-sm" v-if="action == 'view'" @click="atualizar">Atualizar</button>
					<button class="btn btn-success btn-sm" v-if="action == 'add'"  @click="adicionar">Inserir</button>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import api   from "@/mixins/api.js"
	import alert from "@/components/Tools/alert.vue"

	export default {
		name: "modal-ramal",
		props: [ 'ramal', 'action' ],
		mixins: [api],

		data: () => { 
			return {
				incomplete: false,
				setores: { 
					status:null, 
					result:null 
				},

				alert: {
					type: "",
					name: "alert-modal-user",
					msg : ""
				}
			}
		},

		created() {
			this.get_setores();
		},

		computed: {
			logotipo() { 
				return this.$store.state.config.logotipo;
			},

			view_nome(){ 
				return this.$store.state.config_view_menu;
			},
		},

		methods: {
			async get_setores() {
				this.setores = await this.GET("Setor");
			},

			autocomplete_phone() {
				this.setores.result.forEach( index => ( index.ID == this.ramal.PARENT_ID ) ? this.ramal.PHONE_NUMBER = index.PHONE_NUMBER : '' );
			},

			async adicionar() {
				//
				//	Verifica se todos os dados foram preenchidos
				//
				if ( !this.ramal.PARENT_ID || !this.ramal.EXTENSION || !this.ramal.NAME ){
					window.alert("Preencha os campos obrigatórios!");
					this.incomplete = "focus";
				}else{
					const response = await this.POST("Ramal/New", this.ramal);
					
					if ( response.status == "success") {
						this.$emit("alert", { status: "success", result: "Ramal adicionada com sucesso."} );
					}else {
						this.$emit("alert", { status: "false", result: response.result} );
						window.alert(response.result);
					}
				}
			},

			async atualizar() {
				//
				//	Verifica se todos os dados foram preenchidos
				//
				if ( !this.ramal.PARENT_ID || !this.ramal.EXTENSION || !this.ramal.NAME ){
					window.alert("Preencha os campos obrigatórios!");
					this.incomplete = "focus";
				}else{
					const response = await this.PUT("Ramal", this.ramal);
					
					if ( response.status == "success"){ 
						this.$emit("alert", { status: "success", result: "Ramal atualizada com sucesso com sucesso."} );
					}else{
						this.$emit("alert", { status: "false", result: response.result} );
						window.alert(response.result);
					}
				}
			},

			async deletar() {
				if ( window.confirm(`Isso irá deletar ramal ${this.ramal.EXTENSION} permanentemente.`) ) {
					const response = await this.DELETE('Ramal', this.ramal.ID);
					if ( response.status == "success"){ 
						this.$emit("alert", response );
					}else{
						window.alert(response.result);
					}
				}
			}
		}
	}
</script>

<style scoped>
</style>